import { render, staticRenderFns } from "./MapRegionSelector.vue?vue&type=template&id=2d66c36a&scoped=true"
import script from "./MapRegionSelector.vue?vue&type=script&lang=js"
export * from "./MapRegionSelector.vue?vue&type=script&lang=js"
import style0 from "./MapRegionSelector.vue?vue&type=style&index=0&id=2d66c36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66c36a",
  null
  
)

export default component.exports